/** @module reducerMatch */
const reducerMatch = (reducers, initialState) => (state = initialState, action) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action)
  }
  return state
}
export default reducerMatch
